export const RAISIN_LOGO =
  'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt6edc2e97ec97de8a/67e275e889873789f8f90165/Raisin_brand_evolution_Logo.svg';
